<template>
  <div>
    <p class="tip">输入或粘贴ID或包名，每行一个</p>
    <el-input v-model="input" type="textarea" :rows="12"/>
    <div class="btns">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import API from '@/api/marketManage/miBatchAuto'
export default {
  props: ['cbs', 'id' ],
  data() {
    return {
      input: '',
      loading: false,
    }
  },
  methods: {
    onSubmit() {
      const list = this.input.split(/\n/).filter(v=>v.trim()).map(v=>v.trim());
      if (!list.length) {
        this.$message.error('请输入或粘贴ID或包名');
        return;
      };
      this.loading = true;
      const params = {
        account_id: this.id,
        batch_search: list.toString()
      };
      API.getAppDataList(params).then(({data})=> {
        if (data.err_list.length>0) {
           this.$confirm(`未找到以下产品，请检查输入的ID/包名是否准确，或检查是否已经绑定至目标账户对应客户且是启用状态，是否需要剔除未找到的产品？<p>${data.err_list.join('、')}</p>`, '提示', {
            confirmButtonText: '剔除',
            cancelButtonText: '关闭',
            dangerouslyUseHTMLString: true,
            type: 'error'
          }).then(() => {
            this.cbs.onSubmit(data.list)
          }).catch(() => {})
        }else {
          this.cbs.onSubmit(data.list)
        }
      }).finally(()=> {
        this.loading = false
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.btns {
  margin-top: 25px;
  text-align: center;
}

</style>